import MaskIcon from './MaskIcon'

export default MaskIcon
